module.exports = __webpack_public_path__ + "static/media/bad-gateway.e66e0c96.jpg";